<!-- <div class="header">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <i class="fas fa-anchor"></i>
        <span>MarinePortal Support</span>
      </div>
      <div class="user-info">
        <div class="user-avatar">{{ userInitials }}</div>
        <div>
          <div style="font-weight: 600;">{{ displayName }}</div>
          <div style="font-size: 14px; color: var(--gray-text);">{{ accountLabel }}</div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="container">
  <!-- <div class="view-tabs">
    <button class="view-tab active" type="button">User View</button>
    <button class="view-tab" type="button">Admin View (mps&#64;varuna-sentinels.com)</button>
  </div> -->

  <div class="dashboard-title">
    <h1>Support Ticket System</h1>
    <p>Create and track support tickets for catalog updates, RFQ issues, order dispatch, and more</p>
  </div>

  <div class="quick-actions">
    <button class="action-btn primary-btn" type="button" (click)="openCreateTicket()">
      <i class="fas fa-plus-circle"></i>
      Create New Ticket
    </button>
    <div class="search-box" style="display:flex; align-items:center; gap:8px;">
      <i class="fas fa-search"></i>
      <input
        type="text"
        class="form-control"
        placeholder="Search by Ticket Ref, Category, Buyer Name, Priority"
        [(ngModel)]="searchTerm"
        style="min-width: 280px;"
      />
    </div>
    <button class="action-btn secondary-btn" type="button" (click)="exportTickets()">
      <i class="fas fa-download"></i>
      Export Tickets
    </button>
  </div>

  <div class="stats-container">
    <div class="stat-card">
      <div class="stat-number">{{ stats.total }}</div>
      <div class="stat-label">Total Tickets</div>
    </div>
    <div class="stat-card open">
      <div class="stat-number">{{ stats.open }}</div>
      <div class="stat-label">Open Tickets</div>
    </div>
    <div class="stat-card in-progress">
      <div class="stat-number">{{ stats.inProgress }}</div>
      <div class="stat-label">In Progress</div>
    </div>
    <div class="stat-card resolved">
      <div class="stat-number">{{ stats.resolved }}</div>
      <div class="stat-label">Resolved</div>
    </div>
  </div>

  <div class="ticket-filters">
    <div class="filter-header">
      <h3>Recent Support Tickets</h3>
      <div class="filter-buttons">
        <button class="filter-btn" [class.active]="filterStatus === 'all'" (click)="setFilter('all')">All Tickets</button>
        <button class="filter-btn" [class.active]="filterStatus === 'open'" (click)="setFilter('open')">Open</button>
        <button class="filter-btn" [class.active]="filterStatus === 'inProgress'" (click)="setFilter('inProgress')">In Progress</button>
        <button class="filter-btn" [class.active]="filterStatus === 'resolved'" (click)="setFilter('resolved')">Resolved</button>
        <button class="filter-btn" [class.active]="filterStatus === 'closed'" (click)="setFilter('closed')">Closed</button>
      </div>
    </div>
  </div>

  <div class="ticket-table-container">
    <table class="ticket-table">
      <thead>
        <tr>
          <th>Ticket ID</th>
          <th>Subject</th>
          <th>Category</th>
          <th>Status</th>
          <th>Priority</th>
          <th>Created</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ticket of filteredTickets">
          <td><span class="ticket-id">{{ ticket.id }}</span></td>
          <td>{{ ticket.subject }}</td>
          <td>{{ ticket.category }}</td>
          <td>
            <span class="status-badge" [ngClass]="getStatusClass(ticket.status)">{{ ticket.status }}</span>
            <button
              *ngIf="ticket.status === 'Resolved'"
              class="status-edit-btn"
              type="button"
              (click)="openStatusModal(ticket)"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>
          </td>
          <td [ngClass]="getPriorityClass(ticket.priority)">{{ ticket.priority }}</td>
          <td>{{ ticket.created }}</td>
          <td>
            <div class="action-buttons">
              <button class="view-btn" type="button" *ngIf="allowTicketView" (click)="openTicketDetails(ticket)">
                <i class="fas fa-eye"></i>
                View
              </button>
              <button class="download-btn" type="button" (click)="downloadTicketDocuments(ticket)">
                <i class="fas fa-download"></i>
                Docs
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="support-info">
    <h3>Support Team Contact</h3>
    <p>
      All support tickets are automatically sent to our dedicated support team at mps&#64;varuna-sentinels.com. The team has
      access to all submitted details including attachments.
    </p>
    <div class="support-contact">
      <div class="contact-item">
        <i class="fas fa-envelope"></i>
        <div>
          <div style="font-weight: 600;">Support Email</div>
          <div>mps&#64;varuna-sentinels.com</div>
        </div>
      </div>
      <!-- <div class="contact-item">
        <i class="fas fa-phone"></i>
        <div>
          <div style="font-weight: 600;">Support Hotline</div>
          <div>+1 (800) MARINE-1</div>
        </div>
      </div> -->
      <div class="contact-item">
        <i class="fas fa-clock"></i>
        <div>
          <div style="font-weight: 600;">Response Time</div>
          <div>Within 24 hours</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showValidationModal" [class.active]="showValidationModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Missing Information</h3>
      <button class="close-modal" type="button" (click)="closeValidationModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p>Please fill the following required fields:</p>
      <ul style="padding-left: 20px; margin-top: 10px;">
        <li *ngFor="let msg of validationMessages">{{ msg }}</li>
      </ul>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeValidationModal()">OK</button>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showSuccessModal" [class.active]="showSuccessModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Success</h3>
      <button class="close-modal" type="button" (click)="closeSuccessModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p>{{ successMessage }}</p>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeSuccessModal()">Close</button>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showCreateModal" [class.active]="showCreateModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Create New Support Ticket</h3>
      <button class="close-modal" type="button" (click)="closeModals()">&times;</button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label for="buyerName">Buyer Name *</label>
          <input
            id="buyerName"
            name="buyerName"
            type="text"
            class="form-control"
            placeholder="Please enter Buyer Company Name or Buyer Name"
            [(ngModel)]="buyerName"
            [readonly]="true"
            required
          />
        </div>

        <div class="form-group">
          <label for="ticketSubject">Subject *</label>
          <input id="ticketSubject" name="ticketSubject" type="text" class="form-control" placeholder="Brief description of your issue" [(ngModel)]="newTicket.subject" required />
        </div>

        <div class="form-group">
          <label for="ticketCategory">Category *</label>
          <select id="ticketCategory" name="ticketCategory" class="form-control" [(ngModel)]="newTicket.category" required>
            <option value="">Select a category</option>
            <option value="productSearch">Product Search</option>
            <option value="rfqCreation">RFQ Creation</option>
            <option value="supplierSelection">Supplier Selection &amp; Management</option>
            <option value="quoteComparison">Quote Comparison &amp; Evaluation</option>
            <option value="purchaseOrderManagement">Purchase Order Management</option>
            <option value="orderTracking">Order Tracking &amp; Status</option>
            <option value="invoiceManagement">Invoice Management</option>
            <option value="accountProfile">Account &amp; Profile</option>
            <option value="technicalIssues">Technical Issues</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label for="ticketPriority">Priority *</label>
          <select id="ticketPriority" name="ticketPriority" class="form-control" [(ngModel)]="newTicket.priority" required>
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
            <option value="urgent">Urgent</option>
          </select>
        </div>

        <div class="form-group">
          <label for="ticketDescription">Detailed Description *</label>
          <textarea
            id="ticketDescription"
            name="ticketDescription"
            class="form-control"
            placeholder="Please provide detailed information about the issue. Include steps to reproduce, error messages, and any relevant information."
            rows="6"
            [(ngModel)]="newTicket.description"
            required
          ></textarea>
        </div>

        <div class="form-group">
          <label>Attach Supporting Documents</label>
          <div
            class="file-upload"
            [class.drag-active]="dragActive"
            (click)="triggerFileBrowse(fileInput)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)"
          >
            <i class="fas fa-cloud-upload-alt"></i>
            <p>Click to upload or drag and drop files</p>
            <p style="font-size: 14px; margin-top: 5px;">PDF, DOC, JPG, PNG up to 10MB each</p>
          </div>
          <input #fileInput type="file" multiple style="display: none;" (change)="onFileChange($event)" />
          <div class="file-list" *ngIf="uploadedFiles.length">
            <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
              <div>
                <i class="fas fa-file"></i>
                {{ file.name }} ({{ file.displaySize }})
              </div>
              <button type="button" class="remove-file" (click)="removeFile(i)" style="background:none; border:none; color:var(--danger); cursor:pointer;">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="userEmail">Your Email(s) *</label>
          <input
            id="userEmail"
            name="userEmail"
            type="text"
            class="form-control"
            placeholder="Enter one or more emails separated by commas"
            [(ngModel)]="emailEntry"
            (blur)="syncEmails()"
            (keyup.enter)="syncEmails()"
            required
          />
          <div style="font-size: 12px; color: var(--gray-text); margin-top: 6px;">
            You can add multiple email addresses separated by commas.
          </div>
        </div>

        <div style="background: #f0f8ff; padding: 15px; border-radius: var(--border-radius); margin: 20px 0; border-left: 4px solid var(--secondary-blue);">
          <p style="font-size: 14px;">
            <strong>Note:</strong>
            Upon submission, a detailed email with all information and attachments will be sent to
            <strong>mps&#64;varuna-sentinels.com</strong>.
            You'll receive a confirmation email with your ticket reference number.
          </p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeModals()">Cancel</button>
      <button class="submit-btn" type="button" (click)="submitTicket()">Submit Ticket</button>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showDetailsModal" [class.active]="showDetailsModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Ticket Details</h3>
      <button class="close-modal" type="button" (click)="closeModals()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="ticket-details" *ngIf="selectedTicket">
        <div class="ticket-header">
          <h2>{{ selectedTicket.subject }}</h2>
          <div class="ticket-meta">
            <div class="meta-item">
              <div class="meta-label">TICKET ID</div>
          <div class="meta-value">{{ selectedTicket.id }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">STATUS</div>
              <div class="meta-value">
                <span class="status-badge" [ngClass]="getStatusClass(selectedTicket.status)">{{ selectedTicket.status }}</span>
              </div>
            </div>
            <div class="meta-item">
              <div class="meta-label">PRIORITY</div>
              <div class="meta-value" [ngClass]="getPriorityClass(selectedTicket.priority)">{{ selectedTicket.priority }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">CATEGORY</div>
              <div class="meta-value">{{ selectedTicket.category }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">CREATED</div>
              <div class="meta-value">{{ selectedTicket.created }}</div>
            </div>
          </div>
        </div>

        <div class="ticket-content">
          <div class="ticket-section">
            <h4>Description</h4>
            <div class="description-box" style="white-space: pre-line;">{{ selectedTicket.description }}</div>
          </div>

          <div class="ticket-section">
            <h4>Submitted By</h4>
            <p>{{ selectedTicket.submitter }}</p>
          </div>

          <div class="ticket-section">
            <h4>Attached Documents ({{ (selectedTicket?.attachments?.length || 0) }} files)</h4>
            <div class="attachments-container">
              <div class="attachment-card" *ngFor="let attachment of selectedTicket?.attachments || []">
                <div class="attachment-icon">
                  <i [class]="attachment.icon"></i>
                </div>
                <div class="attachment-info">
                  <div class="attachment-name">{{ attachment.name }}</div>
                  <div class="attachment-size">{{ attachment.size }}</div>
                </div>
                <button class="download-btn" type="button" (click)="downloadAttachment(attachment.name)">
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showEmailModal" [class.active]="showEmailModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Email Sent to mps&#64;varuna-sentinels.com</h3>
      <button class="close-modal" type="button" (click)="closeModals()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="email-preview" *ngIf="emailPreview" id="buyerEmailPreview">
        <div class="email-header">
          <div class="email-to">To: <span class="email-address">mps&#64;varuna-sentinels.com</span></div>
          <div class="email-to" style="margin-top: 10px;">From: <span class="email-address">{{ emailPreview.fromEmail }}</span></div>
          <div class="email-to">Subject: <strong>{{ emailPreview.subject }}</strong></div>
        </div>

        <div class="email-body">
          <div class="email-section">
            <p><strong>Dear Support Team,</strong></p>
            <p>A new support ticket has been created in the Marine Portal system with the following details:</p>
          </div>

          <div class="email-section">
            <h4>Ticket Information:</h4>
            <ul style="padding-left: 20px; margin: 10px 0;">
              <li><strong>Ticket ID:</strong> <span>{{ emailPreview.ticketId }}</span></li>
              <li><strong>Submitted By:</strong> <span>{{ emailPreview.submitter }}</span></li>
              <li><strong>User Email:</strong> <span>{{ emailPreview.userEmail }}</span></li>
              <li><strong>Category:</strong> <span>{{ emailPreview.category }}</span></li>
              <li><strong>Priority:</strong> <span>{{ emailPreview.priority }}</span></li>
              <li><strong>Submission Date:</strong> <span>{{ emailPreview.date }}</span></li>
            </ul>
          </div>

          <div class="email-section">
            <h4>Issue Description:</h4>
            <div style="background: #f8f9fa; padding: 15px; border-radius: var(--border-radius); margin: 10px 0;">
              <p>{{ emailPreview.description }}</p>
            </div>
          </div>

          <div class="email-section">
            <h4>Attached Documents:</h4>
            <p>The following documents are attached to this ticket:</p>
            <ol style="padding-left: 20px; margin: 10px 0;">
              <li *ngFor="let attachment of selectedTicket?.attachments || []">{{ attachment.name }} ({{ attachment.size }})</li>
            </ol>
            <p><em>These files are accessible through the admin dashboard.</em></p>
          </div>

          <div class="email-section">
            <h4>Access Ticket:</h4>
            <p>
              You can view and manage this ticket through the admin dashboard at:
              <strong>https://portal.marine-support.com/admin/tickets/{{ emailPreview.ticketId }}</strong>
            </p>
            <p>Login credentials for admin access have been sent separately.</p>
          </div>

          <div class="email-section">
            <p><strong>Best regards,</strong><br />Marine Portal Support System<br />Automated Notification</p>
          </div>

          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid var(--light-gray); font-size: 12px; color: var(--gray-text);">
            <p>This is an automated email. Please do not reply directly to this message.</p>
            <!-- <p>To respond to this ticket, please use the admin dashboard or email: tickets&#64;varuna-sentinel.com</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeModals()">Close</button>
      <button class="submit-btn" type="button" (click)="printEmailPreview()">
        <i class="fas fa-print"></i>
        Print Email
      </button>
    </div>
  </div>
</div>

<div class="status-modal-overlay" *ngIf="showStatusModal">
  <div class="status-modal">
    <div class="status-modal__header">
      <div>
        <div class="status-modal__title">Update Ticket's Status</div>
        <div class="status-modal__subtitle" *ngIf="pendingStatusTicket">
          Ticket {{ pendingStatusTicket.ticketRefNumber || pendingStatusTicket.id }}
        </div>
      </div>
      <button class="status-modal__close" type="button" (click)="closeModals()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="status-modal__body">
      <label for="statusSelect" class="status-modal__label">Select Status</label>
      <select id="statusSelect" class="form-control" [(ngModel)]="statusUpdateSelection">
        <option *ngFor="let s of statusUpdateOptions" [value]="s">{{ s }}</option>
      </select>
    </div>
    <div class="status-modal__footer">
      <button class="cancel-btn" type="button" (click)="closeModals()">Cancel</button>
      <button class="submit-btn" type="button" (click)="submitStatusUpdate(statusUpdateSelection)">Update</button>
    </div>
  </div>
</div>
